import { SpaceSm, FontLineHeightSm, FontWeightDefault, FontSize4, ColorTextDefault } from "@nxt-costco-com/forge-design-tokens";
const locationSelectorContainer = {
  display: "flex",
  flexDirection: "column"
};
const locationSelectorStyle = {
  a: {
    "&:hover": {
      textDecoration: `underline ${ColorTextDefault}`
    },
    ".MuiTypography-root": {
      color: ColorTextDefault,
      fontSize: FontSize4,
      fontWeight: FontWeightDefault,
      lineHeight: FontLineHeightSm
    }
  },
  display: "flex",
  flexDirection: "column",
  gap: SpaceSm
};
export {
  locationSelectorContainer,
  locationSelectorStyle
};
